<template>
  <div class="py-3 h-100">
    <p
      class="fw-bold mb-5"
      :class="{ 'text-danger': invalidFields.includes('datetime') }"
    >
      Bill of Quantity
    </p>
    <div class="w-100 h-100" v-if="bq">
      <div class="mb-3">
        <label class="small mb-1">Amount Allocated</label>
        <div class="d-flex">
          <div
            class="bg-secondary-subtle text-center fw-bold px-4 py-2 text-dark rounded"
          >
            {{ Helper.formatMoney(bq.amount_allocated) || "n/a" }}
          </div>
        </div>
      </div>

      <!-- <iframe
        v-if="bq.bqFile"
        :src="bq.bqFile.url"
        class="w-100 h-100"
        frameborder="0"
      /> -->

      <div class="mb-3 mt-5">
        <label class="d-block small mb-1">BQ File</label>
        <div
          class="image-grid image-grid-placeholder border-0 bg-dark"
          v-if="bq.bqFile"
        >
          <button
            class="btn btn-dark h-100 w-100 lh-sm"
            @click="currentPdf = bq.bqFile.url"
          >
            <i class="fa-solid fa-file-pdf fa-2x mb-2 d-block" />
            Click to view
          </button>
        </div>
      </div>
    </div>
    <div class="w-100 h-100" v-if="!bq">
      <div v-if="modelsIsValid" class="w-100 py-3 d-flex justify-content-end">
        <button class="btn btn-success mx-1" @click="submitBQ">Submit</button>
        <button class="btn btn-secondary mx-1" @click="cancelAttachment">
          Cancel
        </button>
      </div>

      <div class="mb-5">
        <label class="small mb-1">
          Amount Allocated<sup class="text-danger">*</sup>
        </label>
        <div class="input-group" style="width: 250px">
          <span class="input-group-text border-dark">RM</span>
          <input
            type="number"
            class="form-control border-dark"
            v-model="models.amount_allocated"
          />
        </div>
      </div>

      <label class="small mb-1 d-block">
        BQ File<sup class="text-danger">*</sup>
      </label>

      <div class="image-grid image-grid-placeholder" v-if="!models.filePreview">
        <button class="btn h-100 w-100 fw-bold lh-sm" @click="addFile()">
          <i class="fa-solid fa-plus fa-2x mb-2 d-block" />
          Add BQ File
        </button>
      </div>

      <div class="image-grid image-grid-placeholder border-0 bg-dark" v-else>
        <button
          class="btn btn-dark h-100 w-100 lh-sm"
          @click="currentPdf = models.filePreview"
        >
          <i class="fa-solid fa-file-pdf fa-2x mb-2 d-block" />
          Click to preview
        </button>
      </div>
    </div>

    <pdf-viewer
      :url="currentPdf"
      v-if="currentPdf"
      @close="currentPdf = null"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import PdfViewer from "@/components/PdfViewer";

export default {
  props: ["componentId", "nodStatus", "nodId", "userRole"],
  components: { PdfViewer },
  data() {
    return {
      bq: null,
      bqId: null,
      currentPdf: null,
      fileInput: null,
      invalidFields: [],
      models: {
        amount_allocated: null,
        filePreview: null,
      },
    };
  },
  computed: {
    modelsIsValid() {
      return Object.keys(this.models).every((key) => this.models[key]);
    },
  },
  methods: {
    cancelAttachment() {
      this.fileInput = null;

      if (this.models.filePreview) {
        URL.revokeObjectURL(this.models.filePreview);
      }

      Object.keys(this.models).forEach((key) => {
        this.models[key] = null;
      });

      this.Helper.removeToast("BQ PDF removed");
    },
    submitBQ() {
      Swal.fire({
        icon: "question",
        title: "<h5 class='fw-bold'>Submit bill of quantity?</h5>",
        html: "<p class='mb-0'>This action is not reversible.<br />Data cannot be changed after it is submitted.</p>",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Confirm",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.Helper.toggleLoadingSpinner(true);

          let url = "nod-bqs";
          let apiMethod = "post";

          if (this.bqId) {
            url += `/${this.bqId}`;
            apiMethod = "put";
          }

          let body = {
            amount_allocated: this.models.amount_allocated,
          };

          body.nod_case = this.nodId;

          const [call, error] = await this.Helper.handlePromise(
            this.API[apiMethod](url, body)
          );

          if (error) {
            console.error(error);

            this.triggerAlert("error", error);
          } else {
            this.bqId = call.data.id;

            await this.uploadFileInput(call.data.id);

            const componentStatus = this.nodStatus;

            componentStatus.bq = true;

            await this.API.put(`nod-cases/${this.nodId}`, {
              componentStatus: componentStatus,
            });

            await this.getBq();

            this.fileInput = null;

            if (this.models.filePreview) {
              URL.revokeObjectURL(this.models.filePreview);
            }

            Object.keys(this.models).forEach((key) => {
              this.models[key] = null;
            });

            this.triggerAlert(
              "success",
              "BQ uploaded",
              "componentIsCompleted",
              this.bqId
            );
          }

          this.Helper.toggleLoadingSpinner(false);
        }
      });
    },
    async uploadFileInput(bqId) {
      return new Promise(async (resolve, reject) => {
        let fileModels = {
          ref: "nod-bq",
          refId: bqId,
          field: "bqFile",
          files: "",
        };

        const formData = new FormData();
        Object.keys(fileModels).forEach((key) => {
          if (key != "files") {
            formData.append(key, fileModels[key]);
          } else {
            formData.append("files", this.fileInput, this.fileInput.name);
          }
        });

        const [call, error] = await this.Helper.handlePromise(
          this.API.postForm("upload", formData)
        );

        if (error) {
          return reject(error);
        } else {
          return resolve("OK");
        }
      });
    },
    triggerAlert(icon, text, callback, callbackData) {
      Swal.fire({
        icon: icon,
        title: `<h5>${text}</h5>`,
      }).then(() => {
        if (callback) {
          this.$emit(callback, callbackData);
        }
      });
    },
    addFile() {
      const input = document.createElement("input");

      input.type = "file";

      input.multiple = true;

      input.accept = "application/pdf";

      input.onchange = this.fileChanged;

      input.click();
    },
    fileChanged(e) {
      const files = e.target.files;
      if (!files || !files.length) return;

      Object.values(files).forEach((file) => {
        if (this.models.filePreview) {
          URL.revokeObjectURL(this.models.filePreview);
        }
        this.fileInput = file;
        this.models.filePreview = URL.createObjectURL(file);
      });

      this.Helper.successToast("BQ PDF added");
    },
    async getBq() {
      if (this.bqId) {
        const [call, error] = await this.Helper.handlePromise(
          this.API.get(`nod-bqs/${this.bqId}`)
        );

        if (error) {
          this.triggerAlert("error", "Error getting bq data");
        } else {
          this.bq = call.data;
        }
      }
    },
    async setBqAsRead() {
      if (this.Helper.jkrRoles.includes(this.userRole) && this.bqId) {
        setTimeout(async () => {
          const [call, error] = await this.Helper.handlePromise(
            this.API.put(`nod-bqs/${this.bqId}`, {
              isRead: true,
            })
          );

          if (error) {
            console.error(error);
          }
        }, 3000);
      }
    },
  },
  async mounted() {
    this.Helper.toggleLoadingSpinner(true);

    this.bqId = this.componentId;

    await this.getBq();

    this.Helper.toggleLoadingSpinner(false);

    this.setBqAsRead();
  },
};
</script>